import en from './en'
import th from './th'
export default { th, en }